import React from 'react';
import styled from 'styled-components';
import { Container, Form, Button,  Modal } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { addPatient } from '../../UserFunctions';
import history from '../../../history';


const Styles = styled.div`
    .overlay {
        position: absolute;
        top: 10px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
    }
`;

 
const columns = [
  {
    name: 'Patient ID',
    selector: 'patient_id',
    sortable: true,
  },
  {
    name: 'First Name',
    selector: 'first_name',
    sortable: true,
  },
  {
    name: 'Last Name',
    selector: 'last_name',
    sortable: true,
  },
  {
    name: 'Date of Birth',
    selector: 'date_of_birth',
    sortable: true
  },
  {
    name: 'Gender',
    selector: 'gender',
    sortable: true,
  },
  {
    name: 'Phone Number',
    selector: 'phone_number',
    sortable: true,
  },
  {
    name: 'Address',
    selector: 'address',
    sortable: true,
  }
];
 
export class Patients extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            patients: [],
            MessageModalShow: false,
            id: '',
            first_name: '',
            last_name: '',
            date_of_birth: '',
            gender: 'M',
            address: '',
            phone_number: '',
            EventModalShow: false
        }
        this.onChange = this.onChange.bind(this);
        // this.onSubmit = this.onSubmit.bind(this);
        this.updateState = this.updateState.bind(this);
        this.changeStatus = this.changeStatus.bind(this);
        // this.openModal = this.openModal.bind(this);
    }

    onChange(e) {
      this.setState({[e.target.name]: e.target.value});
    }

    changeStatus() {
      this.setState({ state: this.state });
  } 



  openModal = () => {
    console.log("TEST")
    this.setState({ EventModalShow: true});
  }



    updateState = state => {
        this.setState({ selectedRows: state.selectedRows });
      }

    componentDidMount() {
      
        const url = 'https://server-soroka-demo.herokuapp.com/surgery_requests/get_all';
        fetch(url, {
            method: "GET"
        }).then(res => res.json()).then(patients_data => {
            console.log(patients_data)
            this.setState({patients: patients_data})
        }).catch((err) => {
          console.log(err)
        });
        const urlST = 'https://server-soroka-demo.herokuapp.com/surgeries_types/get_all';
        fetch(urlST , {
          method: "GET"
        }).then(res =>res.json()).then(surgeryT_data => {
          var surgeryT_options = surgeryT_data.map(surT_data =>{
            return(<option key={surT_data.surgery_type_id} value={surT_data.id}>{surT_data.name}</option>)
          });
          this.setState({surgeryTs: surgeryT_data, surgeryTO: surgeryT_options});
        }).catch((err) => {
          console.log(err)
        });
    }

  render() {

    let EventModalClose = () => this.setState({EventModalShow: false});
    function MyVerticallyCenteredModal(props) {

      function onSubmitModal(e) {
        e.preventDefault();

      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();

      today = mm + '/' + dd + '/' + yyyy;

      const pre_op_request = {
        request_id: document.getElementById("request_id").value,
        patient_id: document.getElementById("patient_id").value,
        surgery_type: document.getElementById("surgery_type").value,
        urgency: document.getElementById("	urgency").value,
        complexity: document.getElementById("complexity").value,
        duration: document.getElementById("duration").value,
        status: document.getElementById("status").value,
        cancellations: document.getElementById("cancellations").value,
        specific_senior: document.getElementById("specific_senior").value,
        pre_op_date: document.getElementById("pre_op_date").value,
        schedule_from: document.getElementById("schedule_from").value,
        schedule_deadline: document.getElementById("schedule_deadline").value,
        description: document.getElementById("description").value,
        entrance_date: today
      };
      console.log(pre_op_request)
      addPatient(pre_op_request).then(res => {
        if (res) {
          console.log(pre_op_request);
          console.log(res);
          props.onHide();
          history.push('/pre');
        }
        else {
        }
      })
    }


      return (
          
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Specific Room for a Specific Domain
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="overlay"></div>
                <Container>
                    <Form onSubmit={onSubmitModal}>
                      <Form.Row>
                      <Form.Group as={Col} controlId="request_id">
                            <Form.Label>Request ID:</Form.Label>
                            <Form.Control type="number"/>
                         </Form.Group>
                      <Form.Group as={Col} controlId="surgeryT_id">
                            <Form.Label>Surgery Type</Form.Label>
                            <Form.Control as="select">
                            <option>{null}</option>
                            {props.surgeryto ? props.surgeryto : null}
                          </Form.Control>
                          </Form.Group>
                      </Form.Row>
                         
                         <Form.Row>
                         <Form.Group as={Col} controlId="patient_id">
                            <Form.Label>Patient ID:</Form.Label>
                            <Form.Control type="text"/>
                         </Form.Group>
                         
                          <Form.Group as={Col} controlId="first_name">
                              <Form.Label>First Name:</Form.Label>
                              <Form.Control type="text"/>
                          </Form.Group>
                          <Form.Group as={Col} controlId="last_name">
                            <Form.Label>Last Name:</Form.Label>
                            <Form.Control type="text"/>
                         </Form.Group>
                         
                         
                         <Form.Group as={Col} controlId="gender">
                          <Form.Label>Gender</Form.Label>
                          <Form.Control as="select">
                            <option value="m">Male</option>
                            <option value="f">Female</option>
                          </Form.Control>
                        </Form.Group>

                        </Form.Row>
                        <Form.Row>
                          <Form.Group as={Col} controlId="address">
                            <Form.Label>Address:</Form.Label>
                            <Form.Control type="text"/>
                         </Form.Group>
                          <Form.Group as={Col} controlId="phone_number">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control type="text">
                            </Form.Control>
                          </Form.Group>
                          <Form.Group as={Col} controlId="date_of_birth">
                            <Form.Label>Date of Birth</Form.Label>
                            <Form.Control type="date">
                            </Form.Control>
                          </Form.Group>
                        </Form.Row>

                        <Form.Row>
                          
                        

                        
                          <Form.Group as={Col} controlId="status">
                            <Form.Label>Status</Form.Label>
                            <Form.Control as="select">
                            <option>1.1</option>
                            <option>1.2</option>
                            <option>1.3</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                          </Form.Control>
                          </Form.Group>
                        

                        
                          <Form.Group as={Col} controlId="urgency">
                            <Form.Label>Urgency</Form.Label>
                            <Form.Control as="select">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                            <option>6</option>
                          </Form.Control>
                          </Form.Group>
                        

                        
                          <Form.Group as={Col} controlId="complexity">
                            <Form.Label>Complexity</Form.Label>
                            <Form.Control as="select">
                            <option>1</option>
                            <option>2</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                            <option>6</option>
                          </Form.Control>
                          </Form.Group>

                        
                          <Form.Group as={Col} controlId="duration">
                            <Form.Label>Duration (in minutes)</Form.Label>
                            <Form.Control type="number">
                          </Form.Control>
                          </Form.Group>

                          <Form.Group as={Col} controlId="cancellations">
                            <Form.Label>Cancellations</Form.Label>
                            <Form.Control type="number"></Form.Control>
                          </Form.Group>

                        </Form.Row> 

                        <Form.Row>
                          <Form.Group as={Col} controlId="pre_operation_date">
                            <Form.Label>Pre Operation Examine Date</Form.Label>
                            <Form.Control type="date"></Form.Control>
                          </Form.Group>
                          
                          <Form.Group as={Col} controlId="notes">
                            <Form.Label>Notes</Form.Label>
                            <Form.Control type="text"></Form.Control>
                          </Form.Group>
                          
                        </Form.Row>
                    </Form>
                </Container>
          </Modal.Body>
          <Modal.Footer>
              <Button onClick={onSubmitModal}>Submit</Button>
            <Button variant="danger" onClick={props.onHide}>Close</Button>
          </Modal.Footer>
        </Modal>
      );
    }

   
    
    
    return (
      <Styles>
        <Container>
          <Form>
          <Form.Row>
            <Form.Group as={Col} controlId="status">
              <Form.Label>Status:</Form.Label>
                 <Form.Control as="select" onChange={()=>this.changeStatus()}>
                  <option>1.1</option>
                  <option>1.2</option>
                  <option>1.3</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                </Form.Control>
                
            </Form.Group> 
           
            </Form.Row>       
          </Form>
        </Container>
        <DataTable
          title="Patients list"
          columns={columns}
          highlightOnHover
          data={this.state.patients.filter(function(p){
            return p.status === document.getElementById("status").value
          })}
          selectableRows
          dense
          onSelectedRowsChange={this.updateState}
        />
        
        <Button  onClick = {()=>this.openModal()}>Add Patient</Button>
        <MyVerticallyCenteredModal
             show={this.state.EventModalShow}
             onHide={EventModalClose}
             surgeryto ={this.state.surgeryTO}
            />
        
      </Styles>
    )
  }
};
 
export default Patients
